import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {
  timeline = [
    {
      heading: "Infosys",
      duration: "current",
      content: "Upcoming Full stack develover at Infosys!",
      className: "direction-r"
    },
    {
      heading: "B.Tech",
      duration: "2012 - 2016",
      content: "Successfully completed my B.tech in Electronics and communication Engineering from Padmasri Dr B.V.Raju Institute of Technology.",
      className: "direction-l"
    },
    {
      heading: "Intermediate",
      duration: "2010-2012",
      content: "Successfully completed my intermediate studies in 2012 from Narayana Junior College, S.R.Nagar.\n" +
        "Major: PCM.",
      className: "direction-r"
    },
    {
      heading: "High School",
      duration: "1997-2010",
      content: "Successfully completed my high school studies in 2014 from M.B.Grammar School, Suraram.\n" +
      "Major: MPC.",
      className: "direction-l"
    }

    ]
  constructor() { }

  ngOnInit(): void {
  }

}
